<template>
  <v-container fluid style="padding-left: 300px">
    <v-row>
      <v-col cols="12" offset-lg="1">
        <router-link :to="{ name: 'masterAdminBulkRegistration' }">
          <v-btn color="success" class="ma-2 mb-5" dark tile> 一括登録 </v-btn>
        </router-link>
        <v-btn
          color="primary"
          class="ma-2 mb-5"
          dark
          tile
          :disabled="!selectedSite"
          @click="initializeOrder"
        >
          新規作成
        </v-btn>
        <v-form class="mb-4" style='width: 100%' @submit.prevent="searchOrders">
          <v-card elevation="0" tile outlined>
            <v-card-text>
              <div class="mt-3">検索条件を入力してください</div>
              <v-layout row>
                <v-text-field
                  v-model="searchQuery.idEq"
                  label="ID"
                  style="max-width: 150px"
                  type="number"
                  clearable
                  class="ma-2"
                />
                <v-text-field
                  v-model="searchQuery.titleOrQueryCont"
                  label="キーワード"
                  style="max-width: 400px"
                  clearable
                  class="ma-2"
                />
                <v-text-field
                  v-model="searchQuery.userNameCont"
                  label="ライター名"
                  style="max-width: 150px"
                  clearable
                  class="ma-2"
                />
                <v-select
                  v-model="searchQuery.statusEq"
                  :items="selectableStatuses"
                  style="max-width: 150px"
                  class="ma-2"
                  clearable
                  label="ステータス"
                />
                <v-btn
                  color="primary"
                  dark
                  tile
                  outlined
                  class="ma-2"
                  type="submit"
                  :disabled="!selectedSite"
                  @click="searchOrders"
                  @submit.prevent="searchOrders"
                >
                  検索
                </v-btn>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-form>

        <order-table
          :orders="orders"
          @edit-order="editOrder"
          @delete-order="deleteOrder"
        />

        <infinite-loading
          spinner="spiral"
          class="mt-2"
          :identifier="infiniteId"
          @infinite="infiniteHandler"
        >
          <template v-slot:no-more>
            <v-chip label outlined> 全て表示されました。 </v-chip>
          </template>
          <template v-slot:no-results>
            <v-chip label outlined> 表示できるものがありません。 </v-chip>
          </template>
        </infinite-loading>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" persistent scrollable width="800">
      <order-form
        :order="editableOrder"
        :writers="writers"
        :regulation-bundlers="regulationBundlers"
        @change-order="editableOrder = order"
        @create-order="createOrder"
        @cancel-order="cancelOrder"
        @update-order="updateOrder"
        @cancel-edit="dialog = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
import Qs from 'qs'
import { mapState, mapGetters } from 'vuex'
import { deserialize } from 'deserialize-json-api'
import OrderTable from '@/components/commons/orders/Table'
import OrderForm from '@/components/commons/orders/Form'
import headUtilsMixin from '@/mixins/head_utils'
import { cloneDeep } from 'lodash'

export default {
  components: {
    InfiniteLoading,
    OrderTable,
    OrderForm
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: '発注一覧',
      orders: [],
      page: 1,
      searchQuery: {
        titleOrQueryCont: null,
        idEq: '',
        statusEq: '',
        userNameCont: ''
      },
      infiniteId: +new Date(),
      editableOrder: {},
      editableRankKeywords: {},
      dialog: false,
      writers: [],
      regulationBundlers: [],
      selectedSite: null,
      selectableStatuses: [
        { text: '未応募', value: 0 },
        { text: '執筆中', value: 10 },
        { text: '検収中', value: 30 },
        { text: 'ライター校了', value: 40 },
        { text: 'クライアント校了', value: 50 }
      ]
    }
  },
  computed: {
    ...mapState({
      currentUserAuth: (state) => state.UserAuthStore.currentUserAuth
    }),
    ...mapGetters('UserAuthStore', ['selectableSites'])
  },
  created () {
    this.$watch(
      () => this.$route.params,
      (params) => {
        this.selectedSite = this.selectableSites.find(
          (site) => site.siteKey === params.siteKey
        )
        this.searchOrders()
      }
    )
  },
  mounted () {
    this.selectedSite = this.selectableSites.find(
      (site) => site.siteKey === this.$route.params.siteKey
    )
    this.searchOrders()
  },
  methods: {
    searchOrders () {
      this.page = 1
      this.orders = []
      this.infiniteId++

      const params = { params: { siteKey: this.selectedSiteKey() } }
      axios.get('/api/master/writers', params).then(({ data }) => {
        this.writers = deserialize(data).data
      })
      axios.get('/api/master/regulation_bundlers', params).then(({ data }) => {
        this.regulationBundlers = deserialize(data).data
      })
    },
    infiniteHandler ($state) {
      if (!this.selectedSite) {
        $state.complete()
        return true
      }

      axios
        .get('/api/master/orders', {
          params: {
            page: this.page,
            q: this.searchQuery,
            site_key: this.selectedSiteKey()
          },
          paramsSerializer: function (params) {
            return Qs.stringify(params, { arrayFormat: 'brackets' })
          }
        })
        .then(({ data }) => {
          const fetchedOrders = deserialize(data).data
          if (fetchedOrders.length > 0) {
            this.page++
            this.orders = this.orders.concat(fetchedOrders)
            $state.loaded()
          } else {
            $state.complete()
          }
        })
    },
    editOrder (order) {
      this.editableOrder = cloneDeep(order)
      this.editableOrder.userId = this.editableOrder.userId
        ? this.editableOrder.userId.toString()
        : null
      this.editableOrder.rankKeywords = cloneDeep(order.rankKeywords)
      this.dialog = true
    },
    initializeOrder () {
      this.editableOrder = {
        title: null,
        query: null,
        reccomend: null,
        regulationBundlerId: null,
        requiredWords: null,
        rankKeywords: {
          a: [],
          b: [],
          c: [],
          d: []
        },
        expiredOn: null,
        instruction: null,
        isRemanded: null,
        userId: null
      }
      this.dialog = true
    },
    createOrder (order) {
      this.$store.dispatch('LoaderStore/displayLoader')

      const params = { siteKey: this.selectedSiteKey(), order }

      axios.post('/api/master/orders', params).then(
        () => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.dialog = false
          this.searchOrders()
          const payload = {
            status: 200,
            message: '発注を作成しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.displayErrorMessage(error)
        }
      )
    },
    cancelOrder (order) {
      this.$store.dispatch('LoaderStore/displayLoader')

      const params = { siteKey: this.selectedSiteKey() }
      axios.patch(`/api/master/orders/${order.id}/cancel`, params).then(
        ({ data }) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.dialog = false
          const canceledOrder = deserialize(data).data
          Object.assign(
            this.orders.find((order) => order.id === canceledOrder.id),
            canceledOrder
          )
          const payload = {
            status: 200,
            message: '発注を初期化しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.displayErrorMessage(error)
        }
      )
    },
    updateOrder (order) {
      this.$store.dispatch('LoaderStore/displayLoader')

      const params = { siteKey: this.selectedSiteKey(), order }
      axios.patch(`/api/master/orders/${order.id}`, params).then(
        ({ data }) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.dialog = false
          const updatedOrder = deserialize(data).data
          Object.assign(
            this.orders.find((order) => order.id === updatedOrder.id),
            updatedOrder
          )
          const payload = {
            status: 200,
            message: '発注を更新しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.displayErrorMessage(error)
        }
      )
    },
    deleteOrder (order) {
      this.$store.dispatch('LoaderStore/displayLoader')

      const params = { params: { siteKey: this.selectedSiteKey() } }
      axios.delete(`/api/master/orders/${order.id}`, params).then(
        () => {
          this.$store.dispatch('LoaderStore/hideLoader')
          const index = this.orders.findIndex((v) => v.id === order.id)
          this.orders.splice(index, 1)
          const payload = {
            status: 200,
            message: '発注を削除しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          this.$store.dispatch('LoaderStore/hideLoader')
          this.displayErrorMessage(error)
        }
      )
    },
    displayErrorMessage (error) {
      const payload = {
        status: error.response.status,
        message: error.response.data.message.toString()
      }
      this.$store.dispatch('SystemMessageStore/createMessage', payload)
    },
    selectedSiteKey () {
      return this.selectedSite.siteKey
    }
  }
}
</script>
